/* import __COLOCATED_TEMPLATE__ from './reviewable-field-text.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./reviewable-field-text.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));